// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"d7a4f94b","715":"aa349de3"}[chunkId] + ".chunk.css";
};